/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../wire/ApiCaller";
import type { RandomDataRequest, RandomDataResponse } from "./models";
import { randomDataResponseSchema } from "./schemas";

export class StatusApiClient {
  constructor(private caller: ApiCaller) {}

  async getRandomData(payload: RandomDataRequest, timeout?: number): Promise<RandomDataResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.status.v1.random_data.get",
        variables: {},
      },
      "getRandomData",
      payload,
      { schema: randomDataResponseSchema, timeout },
    );
  }
}
